export default __webpack_public_path__ + "fe7fc0ce80aeb282e69759c6cc86a0d6.jpg";